export const HTML = 1;
export const IFRAME = 2;
export const LINK = 3;

export default Object.freeze({
  HTML,
  IFRAME,
  LINK
});
